module.exports = __webpack_public_path__ + "img/IMG_2273.c540b86d.jpg";